import axiosInstance from '../services/AxiosInstance';

export function getPayments(pageNum = 1, pageSize = 10, searchTerm = "", filterQuery = "") {
    return axiosInstance.get(`payment?pageNum=${pageNum}&pageSize=${pageSize}&search=${searchTerm}&${filterQuery}`);
}

export function getReportPayments( filterQuery = "") {
    return axiosInstance.get(`payment?noPagination=true&populate=userId,subscriptionId.subscriptionPlanId&${filterQuery}`);
}

export function deletePayment(id) {
    return axiosInstance.delete(`payment/${id}`);
}

export function createPayment(data) {
    return axiosInstance.post(`payment`,data);
}

export function updatePayment(id, data) {
    return axiosInstance.put(`payment/${id}`,data);
}
